const en = {
  // 🔹 unionDelegationService (Unions)
  'unionDelegationService.table.title': 'Unions',
  'unionDelegationService.table.filter_by_name': 'Filter by Union Name',
  'unionDelegationService.table.filter_by_name_2': 'Filter by Union Status',
  'unionDelegationService.filter_by_deleted_not_deleted': 'Active',
  'unionDelegationService.table.filter_by_deleted_deleted': 'Deleted',
  'unionDelegationService.table.filter_by_deleted_all': 'All',
  'unionDelegationService.form.create': 'Create Union',
  'unionDelegationService.table.name': 'Union Name',
  'unionDelegationService.table.actions': 'Actions',
  'unionDelegationService.table.actions.edit': 'Edit Union',
  'unionDelegationService.table.actions.delete': 'Delete Union',
  'unionDelegationService.table.modal.restore.title': 'Restore',
  'unionDelegationService.table.modal.restore.phrase': 'Are you sure you want to restore this Union?',
  'unionDelegationService.table.modal.restore.button.cancel': 'Cancel',
  'unionDelegationService.table.actions.restore': 'Restore Union',
  'unionDelegationService.table.modal.delete.title': 'Delete',
  'unionDelegationService.table.modal.delete.phrase': 'Are you sure you want to delete this Union?',
  'unionDelegationService.table.modal.delete.button.cancel': 'Cancel',
  'unionDelegationService.table.modal.delete.button.delete': 'Delete',
  'unionDelegationService.table.modal.restore.done': 'Union successfully restored',
  'unionDelegationService.table.modal.delete.done': 'Union successfully deleted',
  'unionDelegationService.table.no_data': 'No data available',
  'unionDelegationService.form.update': 'Update Union',
  'unionDelegationService.form.unionDelegationServiceName': 'Union Name',
  'unionDelegationService.form.cancel': 'Back',
  'unionDelegationService.restore.error': 'Error restoring the Union',

  // 🔹 serviceContractDelegation (Contracts)
  'serviceContractDelegation.table.title': 'Service Contracts',
  'serviceContractDelegation.table.filter_by_name': 'Filter by Delegation Name',
  'serviceContractDelegation.table.filter_by_name_2': 'Contract Status',
  'serviceContractDelegation.table.filter_by_not_deleted': 'Active',
  'serviceContractDelegation.table.filter_by_deleted': 'Deleted',
  'serviceContractDelegation.table.filter_deleted_all': 'All',
  'serviceContractDelegation.form.create': 'Create Contract',
  'serviceContractDelegation.form.update': 'Update Delegation',
  'serviceContractDelegation.table.name': 'Contract Name',
  'serviceContractDelegation.table.union': 'Union',
  'serviceContractDelegation.table.startDate': 'Start Date',
  'serviceContractDelegation.table.endDate': 'End Date',
  'serviceContractDelegation.table.actions': 'Actions',
  'serviceContractDelegation.table.modal.delete.title': 'Delete',
  'serviceContractDelegation.table.modal.delete.phrase': 'Are you sure you want to delete this Delegation?',
  'serviceContractDelegation.table.modal.delete.button.cancel': 'Cancel',
  'serviceContractDelegation.table.modal.delete.button.delete': 'Delete',
  'serviceContractDelegation.table.modal.delete.done': 'Delegation successfully deleted',
  'serviceContractDelegation.table.modal.delete.error': 'Error deleting the Delegation',
  'serviceContractDelegation.table.modal.restore.title': 'Restore',
  'serviceContractDelegation.table.modal.restore.phrase': 'Are you sure you want to restore this Delegation?',
  'serviceContractDelegation.table.modal.restore.button.cancel': 'Cancel',
  'serviceContractDelegation.table.actions.restore': 'Restore Delegation',
  'serviceContractDelegation.table.modal.restore.done': 'Delegation successfully restored',
  'serviceContractDelegation.restore.error': 'Error restoring the Delegation',
  'serviceContractDelegation.table.no_data': 'No data available',
  'serviceContractDelegation.form.serviceContractDelegationName': 'Service Contract Name',
  'serviceContractDelegation.form.unionName': 'Union Name',
  'serviceContractDelegation.form.cancel': 'Back',
  'serviceContractDelegation.form.serviceContactName': 'Contact Name',
  'serviceContractDelegation.restore.success': 'Saved successfully',
  

  // 🔹 serviceContactDelegation (Contacts)
  'serviceContactDelegation.table.title': 'Service Contacts',
  'serviceContactDelegation.table.button.create': 'Create Contact Delegation',
  'serviceContactDelegation.table.filter_by_name': 'Filter by Delegation Name',
  'serviceContactDelegation.table.filter_by_name_2': 'Contact Status',
  'serviceContactDelegation.table.filter_by_not_deleted': 'Active',
  'serviceContactDelegation.table.filter_by_deleted': 'Deleted',
  'serviceContactDelegation.table.filter_by_all': 'All',
  'serviceContactDelegation.form.create': 'Create Contact',
  'serviceContactDelegation.form.update': 'Update Delegation',
  'serviceContactDelegation.table.name': 'Contact Name',
  'serviceContactDelegation.table.phoneNumber': 'Phone Number',
  'serviceContactDelegation.table.Union': 'Union',
  'serviceContactDelegation.table.actions': 'Actions',
  'serviceContactDelegation.table.actions.restore': 'Restore Delegation',
  'serviceContactDelegation.table.modal.delete.title': 'Delete',
  'serviceContactDelegation.table.modal.delete.phrase': 'Are you sure you want to delete this Contact?',
  'serviceContactDelegation.table.modal.delete.button.cancel': 'Cancel',
  'serviceContactDelegation.table.modal.delete.button.delete': 'Delete',
  'serviceContactDelegation.table.modal.delete.done': 'Delegation successfully deleted',
  'serviceContactDelegation.table.modal.delete.error': 'Error deleting the Delegation',
  'serviceContactDelegation.table.modal.restore.title': 'Restore',
  'serviceContactDelegation.table.modal.restore.phrase': 'Are you sure you want to restore this Contact?',
  'serviceContactDelegation.table.modal.restore.button.cancel': 'Cancel',
  'serviceContactDelegation.table.modal.restore.button.restore': 'Restore',
  'serviceContactDelegation.restore.error': 'Error restoring the Delegation',
  'serviceContactDelegation.restore.done': 'Delegation successfully restored',
  'serviceContactDelegation.form.unionName': 'Union Name',
  'serviceContactDelegation.form.cancel': 'Back',
  'serviceContactDelegation.save.success': 'Saved successfully'
};

export default en;